module.exports = __webpack_public_path__ + "static/media/dj_set_2.9d8d1e00.jpg";